// extracted by mini-css-extract-plugin
export var backButton = "FormSent-module--back-button--600ed";
export var btnFacebook = "FormSent-module--btn-facebook--acd7a";
export var btnLinkedin = "FormSent-module--btn-linkedin--18507";
export var btnWechat = "FormSent-module--btn-wechat--0f5a5";
export var btnXing = "FormSent-module--btn-xing--20a24";
export var btnYoutube = "FormSent-module--btn-youtube--1fae0";
export var icon = "FormSent-module--icon--d6c3f";
export var iconText = "FormSent-module--icon-text--ce4cc";
export var leftToRight = "FormSent-module--leftToRight--dc941";
export var mail = "FormSent-module--mail--5f964";
export var phone = "FormSent-module--phone--8a64f";
export var printer = "FormSent-module--printer--3f096";